import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admintraining',
  templateUrl: './admintraining.component.html',
  styleUrls: ['./admintraining.component.scss']
})
export class AdmintrainingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
